import type { C1_FurnitureDefinition } from "../types/C1_FurnitureTypes";

// The registry can register lookups before the furniture model is initialized.
// This module deliberately has no runtime imports of models or catalogs.
export const furnitureResolvers: {
  displayName?: (definitionId: string) => string | undefined;
  definition?: (definitionId: string) => C1_FurnitureDefinition | undefined;
} = {};
